/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import useThrottle from "hooks/useThrottle";
import { ListItemContext } from "cms/fields/field-lists/field-list-context";
import { SimplicityComposerEnsureTipTap } from "cms/rich-text/simplicity-composer-tiptap";
// import { Logger } from "cms/utils/log/logger";

const RichTextFieldItemEdit = () => {

    const throttler = useThrottle();
    const listItemContext = useContext(ListItemContext);
    const index = listItemContext?.index;
    const value = listItemContext?.value;
    const settings = listItemContext?.settings;
    const updateListItem = listItemContext?.updateListItem;

    function onChange (richtext) {
        throttler(() => {
            const update = {
                value: richtext,
                settings
            };
            updateListItem(update, index);
        });
    }

    return (
        <Fragment>
            <div className='simplicity-composer-field-primary-layout'>
                <div className='simplicity-composer-richtext'>
                    <SimplicityComposerEnsureTipTap
                        richtext={value}
                        onChange={onChange}
                    />
                </div>
            </div>
        </Fragment>
    );
};
export default RichTextFieldItemEdit;
